module.exports = __webpack_public_path__ + "img/create-memo-icon.b92b5a34.png";